import React from "react";
import DeviceGenericSkeleton from "./DeviceGenericSkeleton";

function DeviceDetailSkeleton() {
  return (
    <>
      <DeviceGenericSkeleton />
    </>
  );
}

export default DeviceDetailSkeleton;
